import * as urlUtils from 'utils/Url';


// Products
export function getPathProducts(qs={}) {
  return urlUtils.appendQueryString(`/products`, qs);
}

export function getPathProductTags(qs={}) {
  return urlUtils.appendQueryString(`/product-tags`, qs);
}

export function getPathProductGroups(qs={}) {
  return urlUtils.appendQueryString(`/product-groups`, qs);
}


// Conversion Settings
export function getPathConversionSettings() {
  return `/conversion-settings`;
}

export function getPathEditConversionSettings() {
  return `/conversion-settings/edit`;
}


// Web Tracking
export function getPathWebTracking() {
  return `/web-tracking`;
}

export function getPathEditWebTracking() {
  return `/web-tracking/edit`;
}

export function getPathWebTrackingManualInstallation() {
  return `/web-tracking-manual-installation`;
}
